// Generated by GitHub Copilot
import React, { useState, useRef } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import styles from './GCCForum.module.css';
import { useNavigate } from 'react-router-dom';
import nymeetImg from '../../assets/images/newyorkimages/nymeet/leads.png';
import thumbnailImg from '../../assets/images/thumbnail.png';
import chimeetImg from '../../assets/images/ChicagoImage/leadsImg/image (2).png';
// New York — Partners
import nyPartner1 from '../../assets/images/newyorkimages/Partners/image (11).png';
import nyPartner2 from '../../assets/images/newyorkimages/Partners/ANSR.jpg';
// New York — External Participants
import nyExt1 from '../../assets/images/newyorkimages/External participants/image (2).png';
import nyExt2 from '../../assets/images/newyorkimages/External participants/image (3).png';
import nyExt3 from '../../assets/images/newyorkimages/External participants/image (4).png';
import nyExt4 from '../../assets/images/newyorkimages/External participants/image (5).png';
import nyExt5 from '../../assets/images/newyorkimages/External participants/image (6).png';
import nyExt6 from '../../assets/images/newyorkimages/External participants/image (7).png';
import nyExt7 from '../../assets/images/newyorkimages/External participants/image (8).png';
import nyExt8 from '../../assets/images/newyorkimages/External participants/image (9).png';
// Chicago — Partners
import chiPartner1 from '../../assets/images/ChicagoImage/Partners/image (11).png';
import chiPartner2 from '../../assets/images/ChicagoImage/Partners/ANSR.jpg';
// Chicago — External Participants
import chiExt1 from '../../assets/images/ChicagoImage/ExternalParticipants/image (2).png';
import chiExt2 from '../../assets/images/ChicagoImage/ExternalParticipants/image (3).png';
import chiExt3 from '../../assets/images/ChicagoImage/ExternalParticipants/image (4).png';
import chiExt4 from '../../assets/images/ChicagoImage/ExternalParticipants/image (5).png';
import chiExt5 from '../../assets/images/ChicagoImage/ExternalParticipants/image (6).png';
import chiExt6 from '../../assets/images/ChicagoImage/ExternalParticipants/image (7).png';
import chiExt7 from '../../assets/images/ChicagoImage/ExternalParticipants/image (8).png';
import chiExt8 from '../../assets/images/ChicagoImage/ExternalParticipants/image (9).png';
import chiExt9 from '../../assets/images/ChicagoImage/ExternalParticipants/mag.jpg';
// New New York — meet image
import newNyMeetImg from '../../assets/images/newNewyorkImages/nymeet/leads.png';
// New New York — Partners
import newNyPartner1 from '../../assets/images/newNewyorkImages/Partners/image (11).png';
import newNyPartner2 from '../../assets/images/newNewyorkImages/Partners/ANSR.jpg';
// New New York — External Participants
import newNyExt1 from '../../assets/images/newNewyorkImages/External participants/image.jpg';
import newNyExt2 from '../../assets/images/newNewyorkImages/External participants/image (1).jpg';
import newNyExt3 from '../../assets/images/newNewyorkImages/External participants/FedEx Logo and symbol, meaning, history, PNG, brand.jpg';
import newNyExt4 from '../../assets/images/newNewyorkImages/External participants/Download Mizuho Financial Group Logo in SVG Vector or PNG____.png';
import newNyExt5 from '../../assets/images/newNewyorkImages/External participants/Daiichi Sankyo Logo PNG Vector (SVG) Free Download.png';
import newNyExt6 from '../../assets/images/newNewyorkImages/External participants/Global Biotechnology Company _ CSL.jpg';
import newNyExt7 from '../../assets/images/newNewyorkImages/External participants/RBC Logo and symbol, meaning, history, PNG, brand.jpg';
import newNyExt8 from '../../assets/images/newNewyorkImages/External participants/Pfizer - Wikipedia.jpg';
import newNyExt9 from '../../assets/images/newNewyorkImages/External participants/Toyota Logo, symbol, meaning, history, PNG, brand.jpg';

// New York partner and external participant logo arrays
const nyPartners = [nyPartner1, nyPartner2];
const nyExternals = [nyExt1, nyExt2, nyExt3, nyExt4, nyExt5, nyExt6, nyExt8];
// Chicago partner and external participant logo arrays
const chiPartners = [chiPartner1, chiPartner2];
const chiExternals = [chiExt1, chiExt2, chiExt3, chiExt4, chiExt5, chiExt6, chiExt7, chiExt8, chiExt9];
// New New York partner and external participant logo arrays
const newNyPartners = [newNyPartner1, newNyPartner2];
const newNyExternals = [newNyExt1, newNyExt2, newNyExt3, newNyExt4, newNyExt5, newNyExt6, newNyExt7, newNyExt8, newNyExt9];

/**
 * GCC Convergence Forum page.
 * Displays the hero section with event metrics and convergence highlights.
 * Uses the same dark/purple gradient theme as the Home page.
 */
const VIDEO_SRC = '/videos/GCC_Convergence_Chicago.mp4';

const GCCForum = () => {
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  /**
   * Reveals the video element and starts playback.
   * Hides the thumbnail overlay to free memory from the img element.
   */
  const handlePlay = () => {
    setIsPlaying(true);
    setTimeout(() => videoRef.current?.play(), 0);
  };

  return (
    <div className={styles.page}>
      <Navbar />
      <div className={styles.heroPadding} />

      {/* ── Back button bar ── */}
      <div className={styles.backBar}>
        <button
          type="button"
          onClick={() => navigate('/')}
          className={styles.backButton}
          aria-label="Go back to home"
        >
          <svg className={styles.backIcon} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>

      {/* ── Hero Section ── */}
      <section className={styles.heroSection} aria-labelledby="forum-heading">

        {/* Bokeh background blobs */}
        <div aria-hidden="true" className={styles.bokehContainer}>
          <div className={styles.blobLeftLarge} />
          <div className={styles.blobMidLeft} />
          <div className={styles.blobCenterTop} />
          <div className={styles.blobCenter} />
          <div className={styles.blobRight} />
          <div className={styles.blobFarRight} />
        </div>

        {/* Hero content row */}
        <div className={styles.heroContent} style={{ maxWidth: 'min(1160px, 95vw)' }}>

          {/* Left — text column */}
          <div className={styles.heroText}>
            <div className={styles.kicker}>GCC Convergence​</div>
            <h1 id="forum-heading" className={styles.heroHeading}>
              Where GCC Leaders Connect,<br />Collaborate and Shape the Future of Global Capability Centers​
            </h1>
            <p className={styles.lead}>
             Exclusive peer-led forums connecting GCC leaders to exchange insights, activate pipeline opportunities and drive strategic alignment across the GCC lifecycle — from scale to competitive advantage​.
            </p>
          </div>

          {/* Right — video column */}
          <div className={styles.heroVideoCol}>
            <div className={styles.videoWrapper} style={{ aspectRatio: '16 / 9' }}>
              {isPlaying && (
                <video
                  ref={videoRef}
                  className={styles.videoThumbnail}
                  controls
                  preload="metadata"
                  aria-label="GCC Convergence introduction video"
                >
                  <source src={VIDEO_SRC} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              {!isPlaying && (
                <>
                  <img
                    src={thumbnailImg}
                    alt="GCC Convergence event preview"
                    className={styles.videoThumbnail}
                  />
                  <div className={styles.videoGradient} aria-hidden="true" />
                  <button
                    type="button"
                    className={styles.videoLink}
                    aria-label="Play GCC Convergence introduction video"
                    onClick={handlePlay}
                  >
                    <div className={styles.playButton} aria-hidden="true">
                      <svg className={styles.playIcon} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </button>
                </>
              )}
            </div>
          </div>

        </div>
      </section>

      {/* ── Timeline Section ── */}
      <main className={styles.timelineSection} aria-label="GCC Convergence timeline">

        <div className={styles.timeline}>

          {/* ── Event 3: New York Jun 2026 ── */}
          <article className={styles.event}>
            <div className={styles.dot} aria-hidden="true" />
            <div className={styles.dateLabel}>Jun 2026</div>
            <section className={styles.card} aria-labelledby="future-heading">
              <p className={styles.descBanner}>
                Senior executives from leading organizations shared insights on GCC evolution, AI adoption, and enterprise reinvention, exploring strategies to scale innovation, modernize operating models, and accelerate business value through collaboration​.
              </p>
              <div className={styles.eventRow}>
                <div className={styles.cityCol}>
                  <div className={styles.cityLarge} id="future-heading">New York</div>
                  <p className={styles.cardSubtitle}>Cross-Industry Leaders Explore AI, GCC Successes, and Future Priorities​.</p>
                </div>
                <div className={styles.imagesCol}>
                  <img src={newNyMeetImg} alt="New York Jun 2026 Convergence event attendees" className={styles.eventImg} />
                </div>
                <div className={styles.logosCol}>
                  <div>
                    <span className={styles.sectionHeader1}>Partners</span>
                    <div className={styles.partnerLogos}>
                      {newNyPartners.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.partnerLogo} />
                      ))}
                    </div>
                  </div>
                  <div>
                    <span className={styles.sectionHeader}>External participants</span>
                    <div className={styles.participantLogos}>
                      {newNyExternals.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.participantLogo} aria-hidden="true" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>

          {/* ── Event 2: Chicago Feb 2026 ── */}
          <article className={styles.event}>
            <div className={styles.dot} aria-hidden="true" />
            <div className={styles.dateLabel}>Feb 2026</div>
            <section className={styles.card} aria-labelledby="chi-heading">
              <p className={styles.descBanner}>
                Brought together 15 C-suite and VP-level leaders, for candid peer dialogue, generating high-quality engagement and meaningful pipeline impact.
              </p>
              <div className={styles.eventRow}>
                <div className={styles.cityCol}>
                  <div className={styles.cityLarge} id="chi-heading">Chicago</div>
                  <p className={styles.cardSubtitle}>Peer-led conversations and insights.</p>
                </div>
                <div className={styles.imagesCol}>
                  <img src={chimeetImg} alt="Chicago Convergence event attendees" className={styles.eventImg} />
                </div>
                <div className={styles.logosCol}>
                  <div>
                    <span className={styles.sectionHeader1}>Partners</span>
                    <div className={styles.partnerLogos}>
                      {chiPartners.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.partnerLogo} />
                      ))}
                    </div>
                  </div>
                  <div>
                    <span className={styles.sectionHeader}>External participants</span>
                    <div className={styles.participantLogos}>
                      {chiExternals.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.participantLogo} aria-hidden="true" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>

          {/* ── Event 1: New York May 2025 ── */}
          <article className={styles.event}>
            <div className={styles.dot} aria-hidden="true" />
            <div className={styles.dateLabel}>May 2025</div>
            <section className={styles.card} aria-labelledby="nyc-heading">
              <p className={styles.descBanner}>
                Our first-ever GCC forum brought together 14 C-suite leaders, sparking peer-led conversations that earned a perfect relevance score from every attendee.
              </p>
              <div className={styles.eventRow}>
                <div className={styles.cityCol}>
                  <div className={styles.cityLarge} id="nyc-heading">New York</div>
                  <p className={styles.cardSubtitle}>First-ever GCC client event.</p>
                </div>
                <div className={styles.imagesCol}>
                  <img src={nymeetImg} alt="New York Convergence event attendees" className={styles.eventImg} />
                </div>
                <div className={styles.logosCol}>
                  <div>
                    <span className={styles.sectionHeader1}>Partners</span>
                    <div className={styles.partnerLogos}>
                      {nyPartners.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.partnerLogo} />
                      ))}
                    </div>
                  </div>
                  <div>
                    <span className={styles.sectionHeader}>External participants</span>
                    <div className={styles.participantLogos}>
                      {nyExternals.map((src, i) => (
                        <img key={i} src={src} alt="" className={styles.participantLogo} aria-hidden="true" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>

        </div>

        {/* ── CTA strip ── */}
        {/* <section className={styles.cta}>
          <h2 className={styles.ctaHeading}>Design direction: scrollable story, metrics first, event proof points always visible.</h2>
          <a href="#forum-heading" className={styles.ctaLink}>Back to top</a>
        </section> */}

      </main>

      <Footer />
    </div>
  );
};

export default GCCForum;
